
import Civic from "../../../assets/outline/Civic.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function CivicIcon({ className, dataTestid = "CivicIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Civic data-testid={dataTestid} className={classes} {...rest} />
  );
}
